import ChatHeader from './ChatHeader';
import ChatMessageList from './ChatMessageList';
import InputBox from './InputBox';
import { setChatState } from '../actions/ucmaActions';
import { isSessionAbandoned } from '../chatManager/sessionId';
import terminateChatSession from '../services/terminateChatSession';
import ChatState from '../store/schema/ChatState';
import type ChatViewState from '../store/schema/ChatViewState';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import ChatTypingIndicator from './ChatTypingIndicator';

const styles = require('./Chat.scss');
const classnames = require('classnames/bind').bind(styles);

export interface ChatProps {
    chatViewState: ChatViewState;
}

export default observer(function Chat(props: ChatProps) {
    const { chatViewState } = props;

    const sessionAbandoned = isSessionAbandoned(chatViewState.sessionId);

    const userActivity = chatViewState ? chatViewState.userActivity : null;

    const onClickHeader = React.useCallback(() => {
        setChatState(
            chatViewState,
            chatViewState.state == ChatState.Normal ? ChatState.Minimized : ChatState.Normal
        );
    }, [chatViewState, chatViewState.state]);

    const onClickClose = React.useCallback(() => {
        terminateChatSession(chatViewState.sessionId);
        setChatState(chatViewState, ChatState.Closed);
    }, [chatViewState, chatViewState.sessionId]);

    return (
        <div
            className={classnames(styles.chatView, {
                maximized: chatViewState.state == ChatState.Normal,
            })}>
            <ChatHeader
                linkedChatViewState={chatViewState}
                onClickHeader={onClickHeader}
                onClickClose={onClickClose}
            />
            {chatViewState.state == ChatState.Normal && (
                <>
                    <div className={styles.messageContainer}>
                        <ChatMessageList
                            messages={chatViewState.messages}
                            isAbandoned={sessionAbandoned}
                        />
                        {userActivity && !sessionAbandoned && (
                            <ChatTypingIndicator
                                userActivity={userActivity}
                                className={styles.typingIndicatorContainer}
                            />
                        )}
                    </div>
                    <div className={styles.inputContainer}>
                        <InputBox
                            linkedChatViewState={chatViewState}
                            isDisabled={sessionAbandoned}
                        />
                    </div>
                </>
            )}
        </div>
    );
});
